<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav [mode]="mode" [opened]="opened" class="sidenav" (closed)="onClose()">
    <div class="sidenav-header">
      <button mat-icon-button (click)="toggle()" class="toggle-button">
        <mat-icon>{{ opened ? "menu_open" : "menu" }}</mat-icon>
      </button>
    </div>
    <mat-nav-list>
      <ng-container *ngFor="let item of items">
        <!-- Item sem filhos -->
        <a
          *ngIf="!item.children || item.children.length === 0"
          mat-list-item
          [routerLink]="item.route"
          routerLinkActive="active-link"
          (click)="handleItemClick(item)"
        >
          <mat-icon *ngIf="item.icon" matListItemIcon>{{ item.icon }}</mat-icon>
          <span matListItemTitle>{{ item.label }}</span>
        </a>

        <!-- Item com filhos (expansível) -->
        <div *ngIf="item.children && item.children.length > 0">
          <a mat-list-item (click)="handleItemClick(item)" class="parent-item">
            <mat-icon *ngIf="item.icon" matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.label }}</span>
            <mat-icon class="expand-icon">
              {{ item.expanded ? "expand_less" : "expand_more" }}
            </mat-icon>
          </a>

          <div class="submenu" *ngIf="item.expanded">
            <a
              *ngFor="let child of item.children"
              mat-list-item
              [routerLink]="child.route"
              routerLinkActive="active-link"
              class="submenu-item"
            >
              <mat-icon *ngIf="child.icon" matListItemIcon>{{ child.icon }}</mat-icon>
              <span matListItemTitle>{{ child.label }}</span>
            </a>
          </div>
        </div>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <mat-toolbar class="content-toolbar" color="primary">
      <button mat-icon-button (click)="toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="toolbar-title" *ngIf="companyLabel">{{ companyLabel }}</span>
      <span class="toolbar-spacer"></span>
      <div class="toolbar-user" *ngIf="userName">
        <mat-icon class="user-icon">account_circle</mat-icon>
        <span class="user-name">{{ userName }}</span>
      </div>
      <button *ngIf="showLogout" mat-stroked-button color="warn" class="logout-button" (click)="onLogout()">
        <mat-icon>logout</mat-icon>
        <span>Sair</span>
      </button>
    </mat-toolbar>
    <div class="content-wrapper">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
